<template>
  <transition name="fade">
    <div class="modal" v-if="show">
      <div class="modalOverlay"></div>
      <div class="modalContent">
        <div class="loading" v-if="loading"></div>
        <h4 v-html="data.title"></h4>
        <form v-on:submit.prevent="handleSubmit">
          <div :class="{fieldGroup: true, hasError: form.name.error}">
            <input type="text" class="field" placeholder="Page Name"
              v-model="form.name.model" v-on:input="fieldChanged('name')">
            <div class="fieldError" v-if="form.name.error">
              Please input name to continue.</div>
            <div class="fieldHint">Input page name.</div>
          </div>
          <div class="fieldGroup">
            <label class="checkLabel">
              <input type="checkbox" v-model="fieldCheck">
              Publish this page
            </label>
          </div>
          <div v-if="data && data.model && data.model.bodykey === 1">
            <div :class="{sliderImg: true}"
              v-on:click="changeImg" v-if="!image">
              <div class="addPhoto">
                <img src="../assets/photo-black.png">
                <span>Banner Image</span>
              </div>
            </div>
            <div class="sliderImg" v-on:click="changeImg" v-else
              :style="{'background-image': `url(${image.imageLg})`}">
              <div class="addPhoto changePhoto">
                <div>
                  <img src="../assets/photo-white.png">
                  <span>Change Banner Image</span>
                </div>
              </div>
            </div>
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Page Title"
              v-model="form.pageTitle.model">
            <div class="fieldError">Please input name to continue.</div>
          </div>
          <div class="fieldGroup">
            <input type="text" class="field" placeholder="Page Subtitle"
              v-model="form.pageSubtitle.model">
            <div class="fieldError">Please input name to continue.</div>
          </div>
          <textarea placeholder="Description..."
            class="field" rows="3" v-model="form.description.model"/>
          <div class="fieldHint">Write something about this page.</div>

          <div v-if="data && data.model && data.model.bodykey === 0">
            <h4 class="sliderTitle">Image Slider</h4>
            <div :class="{sliderImg: true, theSlider: true}"
              v-on:click="addImgSlider">
              <div class="addPhoto">
                <img src="../assets/photo-black.png">
                <span>Add Image</span>
              </div>
            </div>
          </div>

          <div class="modalAction">
            <div class="deleteCat" v-on:click="deleteCat"
              v-if="data.model && data.model.id">
              Delete Page
            </div>
            <button class="btn btnSecondary" type="button"
              v-on:click="close(false)">Cancel</button>
            <button class="btn btnPrimary" type="submit">
              <span v-if="data.action">{{data.action}}</span>
              <span v-else>Insert</span>
            </button>
          </div>
        </form>
      </div>
      <Confirmation ref="confirmDialog"/>
      <FormInputerShort ref="formInputer"/>
      <AddImageSlider ref="addImageSlider"/>
      <MediaSelector ref="mediaSelector"/>
    </div>
  </transition>
</template>

<script>
import Confirmation from '@/components/Confirmation.vue';
import FormInputerShort from '@/components/FormInputerShort.vue';
import AddImageSlider from '@/components/AddImageSlider.vue';
import MediaSelector from '@/components/MediaSelector.vue';

export default {
  name: 'addArticleCategory',
  components: {
    Confirmation,
    FormInputerShort,
    AddImageSlider,
    MediaSelector,
  },
  data() {
    return {
      show: false,
      loading: false,
      fieldCheck: true,
      image: null,
      form: {
        name: { model: '', error: null },
        pageTitle: { model: '' },
        pageSubtitle: { model: '' },
        description: { model: '' },
      },
      data: {
        id: null,
        name: '',
        pageTitle: '',
        placeholder: '',
        action: '',
        description: '',
        model: null,
        required: '',
      },
      next: null,
    };
  },
  methods: {
    open(d, n) {
      this.image = (d && d.model && d.model.bannerImg) ? d.model.bannerImg : null;
      this.form.name.model = (d && d.model && d.model.name) ? d.model.name : '';
      this.form.pageTitle.model = (d && d.model && d.model.pageTitle)
        ? d.model.pageTitle : '';
      this.form.pageSubtitle.model = (d && d.model && d.model.pageSubtitle)
        ? d.model.pageSubtitle : '';
      this.form.description.model = (d && d.model && d.model.description)
        ? d.model.description : '';
      this.form.name.error = null;
      this.data = d;
      this.next = n;
      this.show = true;
      this.fieldCheck = (!d.model || d.model.visibility === 'visible');
    },
    close(b, d) {
      this.show = false;
      if (this.next && typeof this.next === 'function') this.next(b, d);
    },
    changeImg() {
      this.$refs.mediaSelector.open({}, (b, media) => {
        if (b) this.image = media;
      });
    },
    addImgSlider() {
      this.$refs.addImageSlider.open();
    },
    handleSubmit() {
      if (this.required && !this.field) {
        this.fieldError = true;
        return;
      }
      const visibility = this.fieldCheck ? 'visible' : 'hidden';
      const formData = {
        name: this.form.name.model,
        pageTitle: this.form.pageTitle.model,
        pageSubtitle: this.form.pageSubtitle.model,
        description: this.form.description.model,
        visibility,
      };
      if (this.image) formData.bannerImg = this.image.id;
      if (this.data.model && this.data.model.id) {
        formData.id = this.data.model.id;
      }
      this.loading = true;
      this.$http.post(this.$config.uri('article/page'), formData).then((response) => {
        this.loading = false;
        this.close(true, response.data.data);
      });
    },
    fieldChanged() {
      this.fieldError = false;
    },
    deleteCat() {
      this.$refs.confirmDialog.open({
        title: `Delete ${this.data.model.name}`,
        desc: `Are you sure you want to delete this category? If you not tick delete content
          all content this category will not be deleted, but will not be accesible.`,
        checkbox: 'Also delete content in this category',
      }, (b, c) => {
        if (!b) return;
        this.deleteNow(c);
      });
    },
    deleteNow(c) {
      this.$refs.formInputer.open({
        title: 'Input Password',
        subtitle: 'To prevent from accidentally deleted category, you need to input your password.',
        placeholder: 'Password',
        type: 'password',
        action: 'Delete Category',
      }, (b) => {
        if (!b) return;
        this.loading = true;
        const cx = (c) ? 'YES' : 'NO';
        this.$http.get(this.$config.uri(`article/page/${this.data.model.id}
          /delete?content=${cx}`)).then((response) => {
          this.loading = false;
          this.close(true, { type: 'delete' });
        });
      });
    },
  },
};
</script>

<style scoped lang="scss">
  .sliderImg{
    height: 160px;
    background-color: #eee;
    border-radius: 7px;
    margin-bottom: 20px;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: background-color .3s ease;
    cursor: pointer;
    position: relative;
    overflow: hidden;
    background-size: cover;
    background-position: center;
    .addPhoto{
      color: #999;
      font-weight: bold;
      font-size: 18px;
      transition: all .3s ease;
      img{
        height: 46px;
        opacity: .3;
        display: block;
        margin: 0 auto 6px;
        transition: all .3s ease;
      }
      &.changePhoto{
        color: #fff;
        opacity: 0;
        background-color: rgba(0,0,0,.5);
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        display: flex;
        align-items: center;
        justify-content: center;
        img{
          opacity: 1;
        }
      }
    }
    &.theSlider{
      width: 100px; height: 100px;
      .addPhoto{
        img{
          height: 30px;
        }
        font-size: 14px;
      }
    }
    &:hover{
      background-color: #e5e5e5;
      .addPhoto{
        color: #767676;
        img{
          opacity: .4;
        }
        &.changePhoto{
          opacity: 1;
          color: #fff;
          img{
            opacity: 1;
          }
        }
      }
    }
    &.hasError{
      border: red 2px solid;
      box-sizing: border-box;
      background-color: #fff3f3;
    }
  }

  .modal{
    position: fixed;
    top: 0; left: 0; right: 0; bottom: 0;
    z-index: 99;
    display: flex;
    align-items: center;
    justify-content: center;
    .modalOverlay{
      position: fixed;
      top: 0; left: 0; right: 0; bottom: 0;
      background-color: rgba(0,0,0,.7);
      // backdrop-filter: saturate(180%) blur(20px);
      z-index: 1;
      opacity: 1;
    }
    .modalContent{
      position: absolute;
      background-color: #fff;
      z-index: 2;
      padding: 30px 80px;
      border-radius: 5px;
      margin-top: -20px;
      text-align: center;
      overflow: hidden;
      max-width: none;
      width: 400px;
      h4.sliderTitle{
        font-size: 12px;
        text-transform: uppercase;
        font-weight: 600;
        color: #999;
        margin: 16px 7px 6px;
      }
      .loading{
        position: absolute;
        top: 0; left: 0; right: 0; bottom: 0;
        background-color: #fff;
        background-color: rgba(255,255,255,.7);
        backdrop-filter: saturate(180%) blur(20px);
        background-image: url(../assets/loading.svg);
        background-position: center;
        background-size: 70px auto;
        background-repeat: no-repeat;
        z-index: 9;
      }
      .fieldGroup{
        label.checkLabel{
          text-align: left;
          text-transform: none;
          color: #444;
          margin: 0;
          padding: 5px 0;
          cursor: pointer;
          font-size: 17px;
          font-weight: 600;
          input{
            margin: 0;
            margin-left: 3px;
            margin-top: 4px;
            margin-right: 10px;
            float: left;
          }
        }
      }
      textarea{
        margin-top: 20px;
      }
      h4{
        margin: 0;
        font-size: 24px;
        font-weight: normal;
        margin-bottom: 20px;
        color: #444;
        text-align: left;
      }
      p{
        margin: 0;
        color: #767676;
      }
      .modalAction{
        margin: 30px -80px -30px;
        padding: 12px 30px;
        text-align: right;
        // background-color: #eee;
        border-top: #eee 1px solid;
        position: relative;
        .deleteCat{
          position: absolute;
          left: 30px; top: 22px;
          color: red; cursor: pointer;
          padding-left: 22px;
          opacity: .8;
          &:before{
            display: block;
            content: "";
            position: absolute;
            left: 0; top: 0;
            width: 16px; height: 20px;
            background-image: url(../assets/delete.png);
            background-size: 14px auto;
            background-position: center;
            background-repeat: no-repeat;
          }
          &:hover{
            opacity: 1;
          }
        }
        .btn{
          margin-left: 10px;
        }
      }
    }
  }
</style>
